import Grid from '@mui/material/Grid';
import {styled} from '@mui/material/styles';

const MuiGrid = styled(Grid)(({_theme}) => ({}));

export default MuiGrid;
